import  * as actions from '../actions/actionTypes';
import { IStatsPlayerAggregateState, IState } from '../store/state';

const statsPlayerAggregate = (state: IStatsPlayerAggregateState = {}, action: any) : IStatsPlayerAggregateState => {
	switch (action.type) {
	case actions.FETCH_STATS_PLAYER_AGGREGATE_SUCCEEDED:
		return Object.assign({}, state, action.data);
	case actions.FETCHING_STATS_ABORTED:
	case actions.FETCH_STATS_PLAYER_AGGREGATE_FAILED:
		console.error(action.type, action.data);
		return Object.assign({}, state, action.data);
    default:
      	return state;
  }
};

export const getLastServiceGamesWon = (state: IState, isHomeOrAway: any, channel: number) => {
	try {
		// isHomeOrAway contains string 'home' or 'away', depending on that data is chosen
		// content of statsPlayerAggregate is data of both players, it is set in
		// poller.ts: getStatsPlayerAggregateFeedData()
		let homeOrAway = isHomeOrAway == 'home' ? 0 : 1;
		return  state.statsPlayerAggregate[channel][homeOrAway].doc[0].data && state.statsPlayerAggregate[channel][homeOrAway].doc[0].data.most_recent_match ?
			state.statsPlayerAggregate[channel][homeOrAway].doc[0].data.most_recent_match.last_service_games_won : 0;
	} catch (error) {
		//console.error('getLastServiceGamesWon: something went wrong :( ', error);
		return {};
	}
};

export const getLastServicePointsWon = (state: IState, isHomeOrAway: any ,channel: number) => {
	try {
		let homeOrAway = isHomeOrAway == 'home' ? 0 : 1;
		return state.statsPlayerAggregate[channel][homeOrAway].doc[0].data && state.statsPlayerAggregate[channel][homeOrAway].doc[0].data.most_recent_match  ?
			state.statsPlayerAggregate[channel][homeOrAway].doc[0].data.most_recent_match.last_service_points_won : 0;
	} catch (error) {
		//console.error('getLastServicePointsWon: something went wrong :( ', error);
		return {};
	}
};

	export const getLastTiebreakGamesWon = (state: IState, isHomeOrAway: any, channel: number) => {
	try {
		let homeOrAway = isHomeOrAway == 'home' ? 0 : 1;
		return state.statsPlayerAggregate[channel][homeOrAway].doc[0].data && state.statsPlayerAggregate[channel][homeOrAway].doc[0].data.most_recent_match  ?
			state.statsPlayerAggregate[channel][homeOrAway].doc[0].data.all.last_tiebreak_games_won : 0;
	} catch (error) {
		//console.error('getLastTiebreakGamesWon: something went wrong :( ', error);
		return {};
	}
};

export default statsPlayerAggregate;
